var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 6V11C14.5 12.3807 13.3807 13.5 12 13.5C10.6193 13.5 9.5 12.3807 9.5 11V6C9.5 4.61929 10.6193 3.5 12 3.5C13.3807 3.5 14.5 4.61929 14.5 6ZM7.5 6C7.5 3.51472 9.51472 1.5 12 1.5C14.4853 1.5 16.5 3.51472 16.5 6V11C16.5 13.4853 14.4853 15.5 12 15.5C9.51472 15.5 7.5 13.4853 7.5 11V6ZM6 10.5C6 9.94771 5.55228 9.5 5 9.5C4.44772 9.5 4 9.94771 4 10.5C4 12.4007 4.48574 14.5104 5.75584 16.1702C6.90161 17.6675 8.62948 18.7221 11 18.9526V21H8.5C7.94772 21 7.5 21.4477 7.5 22C7.5 22.5523 7.94772 23 8.5 23H15.5C16.0523 23 16.5 22.5523 16.5 22C16.5 21.4477 16.0523 21 15.5 21H13V18.9526C15.3705 18.7221 17.0984 17.6675 18.2442 16.1702C19.5143 14.5104 20 12.4007 20 10.5C20 9.94771 19.5523 9.5 19 9.5C18.4477 9.5 18 9.94771 18 10.5C18 12.0993 17.5857 13.7396 16.6558 14.9548C15.757 16.1294 14.3088 17 12 17C9.69118 17 8.24302 16.1294 7.34416 14.9548C6.41426 13.7396 6 12.0993 6 10.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMic);
export default __webpack_public_path__ + "static/media/ic_mic.524d15c0cd023dc132e81ec756f9ca3e.svg";
export { ForwardRef as ReactComponent };